import React, { FC, ReactNode } from 'react';
import { ContentBlockWrapper, ContentWrapper, Typography } from '@raisin/components-lib';
import * as S from './styles';

interface BankAffiliateBannerProps {
  title: string;
  subtitle?: ReactNode | string;
  listItems: string[];
  imageSrc: string;
}

export const BankAffiliateBanner: FC<BankAffiliateBannerProps> = ({
  title,
  subtitle,
  listItems = [],
  imageSrc,
}) => (
  <ContentBlockWrapper backgroundColor="background">
    <ContentWrapper>
      <S.BannerContainer>
        <S.BannerContent>
          <S.ContentSection>
            <S.Heading variant="h2">{title}</S.Heading>
            {listItems?.length > 0 && (
              <S.ListContainer>
                {listItems.map((item: string, index) => (
                  <S.ListItem key={index} data-testid="hero-list-item">
                    <S.CheckmarkIcon src="/cp_assets/checkmark-dark.svg" alt="checkmark-icon" />
                    <Typography variant="subtitle1">{item}</Typography>
                  </S.ListItem>
                ))}
              </S.ListContainer>
            )}
            {subtitle && <S.SubTitle data-testid="hero-subtitle">{subtitle}</S.SubTitle>}
          </S.ContentSection>
          <S.SideImageWrapper>
            <S.SideImageContainer src={imageSrc} alt="bank logo" />
          </S.SideImageWrapper>
        </S.BannerContent>
      </S.BannerContainer>
    </ContentWrapper>
  </ContentBlockWrapper>
);
